import React from 'react';
import PropTypes from 'prop-types';
import api from 'api';
import Component from 'BaseComponent';
import { notice, alert } from 'ducks/notifications';
import { reduxForm } from 'redux-form';
import convertToFormErrors from 'utils/convertToFormErrors';
import { withRouter } from 'react-router-dom';
import Form from 'form/Form';
import { connect } from 'react-redux';
import SubmitButton from 'form/SubmitButton';

@withRouter

@connect((state, props) => ({
  initialValues: props.site && props.site.attributes,
}))

@reduxForm({
  form: 'EnableSsl',
  onSubmit(values, dispatch, props) {
    const { site } = props;
    if (site.attributes.staticDomainSsl) {
      return dispatch(api.disableSsl(
        { id: site.id },
        {
          data: {
            type: 'site',
            attributes: { },
          },
        },
      ))
      .then(() => {
        props.history.push(`/site/${site.id}`);
        dispatch(notice('DisableSsl.success'));
      })
      .catch((response) => {
        dispatch(alert('DisableSsl.error'));
        return Promise.reject(convertToFormErrors(response));
      });
    }
    return dispatch(api.enableSsl(
      { id: site.id },
      {
        data: {
          type: 'site',
          attributes: { },
        },
      },
    ))
    .then(() => {
      props.history.push(`/site/${site.id}`);
      dispatch(notice('EnableSsl.success'));
    })
    .catch((response) => {
      dispatch(alert('EnableSsl.error'));
      return Promise.reject(convertToFormErrors(response));
    });
  },
})

export default class Https extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    error: PropTypes.string,
    site: PropTypes.object.isRequired,
  }

  render() {
    const { site, handleSubmit, submitting, error } = this.props;

    return (
      <div>
        <div>
          <p>
            HardyPress offers free SSL for your site.
            <br />
            To enable it, click the button below and wait about 30 seconds. That&#39;s it!
            <br />
            <br />
            Enabling SSL site automatically will
            force every request to be in https with a 301 redirect.
          </p>
          <br />
          <p>
            <small>
              <i>Technical details: </i>
              HardyPress uses Let&#39;s Encrypt to provide a fully automated HTTPS/TLS/SSL install.
              We automatically provision a certificate, install it on our CDN,
              set up a redirect from http://
              {site.attributes.staticDomain}
              {' '}
              to https://
              {site.attributes.staticDomain}
              {' '}
              and adjust the WordPress site URL.
            </small>
          </p>
        </div>
        <br />
        <Form error={error} onSubmit={handleSubmit}>
          <SubmitButton
            className="button button--primary button--expand button--huge"
            submitting={submitting}
            label={site.attributes.staticDomainSsl ? 'DisableSsl.submit' : 'EnableSsl.submit'}
            dirty
          />
        </Form>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/Https.jsx